import moment from 'moment';
import _ from 'underscore';

/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
// Create or show picker
$(document).on('focus', 'input.date_range', function inputDateRange() {
  window.merchantos.dateRange.show(this);
});

/**
 * We use this date format instead of the standard ISO8601 time format because Sugar 1.4.1 used to use this format:
 * https://github.com/andrewplummer/Sugar/blob/1.4.1/lib/date.js#L1633
 * The latest version of Sugar seems to have corrected this to use proper ISO format:
 * https://github.com/andrewplummer/Sugar/blob/master/lib/date.js#L178
 * We're using the legacy one for compatibility purposes as a 'quick fix'.
 * TODO: Rip out Sugar + all of the date formatting entirely
 */
const LEGACY_ISO8601_DATE = '{yyyy}-{MM}-{dd}';

/**
 * Same as above; The legacy short format has changed in Sugar versions
 * https://github.com/andrewplummer/Sugar/blob/1.4.1/lib/date.js#L2406
 * https://github.com/andrewplummer/Sugar/blob/master/lib/date.js#L4046
 */
const LEGACY_SHORT_DATE = '{Month} {d}, {yyyy}';

const DEFAULT_MIN_DAY = '1900-01-01';
const DEFAULT_MAX_DAY = '2038-01-01';

window.merchantos.dateRange = {
  startingDate: undefined,
  endingDate: undefined,
  domObject: undefined,
  field: undefined,
  fieldContainer: undefined,
  hiddenStartField: undefined,
  hiddenEndField: undefined,
  regexp: {
    to: /[\s]+to[\s]+|[\s]+-[\s]+/i,
    on: /^(?:(?:on|=)\s*)?[\d-]+$/i,
    before: /(?:before|<)\s*[\d-]+/i,
    after: /(?:after|>)\s*[\d-]+/i,
  },
  i18n: undefined,

  setRegexp() {
    this.regexp.on = new RegExp(
      `^(?:(?:${this.i18n.on.replace(/\s*\{.*?}\s*/g, '')}|=)\\s*)?[\\d-]+$`,
      'i'
    );
    this.regexp.before = new RegExp(
      `(?:${this.i18n.before.replace(/\s*\{.*?}\s*/g, '')}|<)\\s*[\\d-]+`,
      'i'
    );
    this.regexp.after = new RegExp(
      `(?:${this.i18n.after.replace(/\s*\{.*?}\s*/g, '')}|>)\\s*[\\d-]+`,
      'i'
    );
  },

  set(field, value) {
    // You can only set startingDate and endingDate
    if (field === 'startingDate' || field === 'endingDate') {
      if (value === undefined) {
        this[field] = undefined;
      } else {
        // Recreate data object to make sure we don't get a reference
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'create' does not exist on type 'DateCons... Remove this comment to see the full error message
        this[field] = Date.create(value);
      }

      this.reCalc();
      return true;
    }

    return false;
  },

  reCalc() {
    // Show hide the open-ended range functions
    this.toggleOpenEnded();

    // Update the hidden fields used in actual submission
    this.updateHiddenFields();

    // Update origin field
    this.updateField();

    // Update humanized fields
    this.updateHumanized();

    // Update fields
    this.updatePickerFields();

    // Update calendar
    this.updateCalendars();
  },

  setInfinite(from) {
    if (from === 'start') {
      this.set('startingDate', undefined);
    } else {
      this.set('endingDate', undefined);
    }
  },

  toggleOpenEnded() {
    if (
      this.startingDate !== undefined &&
      this.endingDate !== undefined &&
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'full' does not exist on type 'Date'.
      this.startingDate.full() === this.endingDate.full()
    ) {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      this.domObject.find('.open_range').fadeIn();
    } else {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      this.domObject.find('.open_range').hide();
    }
  },

  selectMonth(month) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'create' does not exist on type 'DateCons... Remove this comment to see the full error message
    this.startingDate = Date.create(month.beginningOfMonth(), { clone: true });
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'endOfMonth' does not exist on type 'Date... Remove this comment to see the full error message
    this.endingDate = month.endOfMonth();
    // this.endingDate = Date.create(month.endOfMonth());
    this.reCalc();
  },

  updateCalendars() {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    const months = this.domObject.find('.date_range_calendars');
    const days = months.find('.month:visible li');

    // Clear current state
    months.find('.selected').removeClass('selected');

    let selected: TSFixMe = [];

    let start: TSFixMe;
    let end: TSFixMe;
    if (this.endingDate !== undefined && this.startingDate !== undefined) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'format' does not exist on type 'Date'.
      start = this.startingDate.format(LEGACY_ISO8601_DATE);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'format' does not exist on type 'Date'.
      end = this.endingDate.format(LEGACY_ISO8601_DATE);

      selected = _.filter(days, (d) => $(d).data('day') >= start && $(d).data('day') <= end);
    } else if (this.startingDate !== undefined) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'format' does not exist on type 'Date'.
      start = this.startingDate.format(LEGACY_ISO8601_DATE);

      selected = _.filter(days, (d) => $(d).data('day') >= start);
    } else if (this.endingDate !== undefined) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'format' does not exist on type 'Date'.
      end = this.endingDate.format(LEGACY_ISO8601_DATE);

      selected = _.filter(days, (d) => $(d).data('day') <= end);
    }

    $(selected).addClass('selected');
  },

  formatted(...args) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Date | undefined' is not assigna... Remove this comment to see the full error message
    const start = this.formatDate(this.startingDate, args[0]);
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Date | undefined' is not assigna... Remove this comment to see the full error message
    const end = this.formatDate(this.endingDate, args[0]);

    let text = '';

    if (start !== undefined && end !== undefined) {
      if (start === end) {
        text = start;
      } else {
        text = window.CalendarLocale.translate(this.i18n.to, start, end);
      }
    } else if (this.startingDate !== undefined) {
      text = window.CalendarLocale.translate(this.i18n.after, start);
    } else if (this.endingDate !== undefined) {
      text = window.CalendarLocale.translate(this.i18n.before, end);
    }

    return text;
  },

  formatDate(date, ...args) {
    let format;
    if (args[0]) {
      format = args[0];
    }

    if (date === undefined) {
      return undefined;
    }
    if (format !== undefined) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'format' does not exist on type 'Date'.
      return date.format(format);
    }
    return this.formatDateFamiliar(date);
  },

  formatDateFamiliar(date) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isToday' does not exist on type 'Date'.
    if (date.isToday()) {
      return window.CalendarLocale.translate(this.i18n.today);
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isYesterday' does not exist on type 'Dat... Remove this comment to see the full error message
    if (date.isYesterday()) {
      return window.CalendarLocale.translate(this.i18n.yesterday);
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isTomorrow' does not exist on type 'Date... Remove this comment to see the full error message
    if (date.isTomorrow()) {
      // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'CalendarLocale'.
      return CalendarLocale.translate(this.i18n.tomorrow);
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isThisWeek' does not exist on type 'Date... Remove this comment to see the full error message
    if (date.isThisWeek()) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'format' does not exist on type 'Date'.
      return date.format('{Weekday}');
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isLastWeek' does not exist on type 'Date... Remove this comment to see the full error message
    if (date.isLastWeek()) {
      // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'CalendarLocale'.
      return CalendarLocale.translate(this.i18n.last, date.format('{Weekday}'));
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isNextWeek' does not exist on type 'Date... Remove this comment to see the full error message
    if (date.isNextWeek()) {
      // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'CalendarLocale'.
      return CalendarLocale.translate(this.i18n.next, date.format('{Weekday}'));
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'format' does not exist on type 'Date'.
    return `${date.format('{Weekday}')}, ${date.format(LEGACY_SHORT_DATE, CalendarLocale.locale)}`;
  },

  formatIfDate(value) {
    if (value === undefined) {
      return '';
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'format' does not exist on type 'Date'.
    return value.format(LEGACY_ISO8601_DATE);
  },

  updateHiddenFields() {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    this.hiddenStartField.val(this.formatIfDate(this.startingDate));
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    this.hiddenEndField.val(this.formatIfDate(this.endingDate));
  },

  updateField() {
    // Don't change if the field is actively focused (user is typing there)
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    if (!this.field.is(':focus')) {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      this.field.val(this.formatted(LEGACY_ISO8601_DATE));
    }
  },

  updateHumanized() {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    this.domObject.find('.humanized').text(this.formatted());
  },

  updatePickerField(field, value) {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    // eslint-disable-next-line no-param-reassign
    field = this.domObject.find(`input[class="${field}"]`);

    if (value === undefined) {
      field.val('');
    } else {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'format' does not exist on type 'string'.
      field.val(value.format(LEGACY_ISO8601_DATE));
    }
  },

  updatePickerFields() {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
    this.updatePickerField('start', this.startingDate);
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
    this.updatePickerField('end', this.endingDate);
  },

  pickDay(date) {
    // If a starting date isn't set than that's what this is

    // Both ends are set
    if (this.startingDate && this.endingDate) {
      // It's a single day match
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'full' does not exist on type 'Date'.
      if (this.startingDate.full() === this.endingDate.full()) {
        // If they're picking a date before the ending date swap the
        // dates so that the just selected date is the starting date
        if (this.endingDate < date) {
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Date' is not assignable to param... Remove this comment to see the full error message
          this.set('endingDate', date);
        } else {
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Date' is not assignable to param... Remove this comment to see the full error message
          this.set('startingDate', date);
        }
      } else {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Date' is not assignable to param... Remove this comment to see the full error message
        this.set('endingDate', date);
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Date' is not assignable to param... Remove this comment to see the full error message
        this.set('startingDate', date);
      }
    } else {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Date' is not assignable to param... Remove this comment to see the full error message
      this.set('endingDate', date);
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Date' is not assignable to param... Remove this comment to see the full error message
      this.set('startingDate', date);
    }
  },

  show(field) {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    field.picker = this;
    // @ts-expect-error ts-migrate(2740) FIXME: Type 'JQueryStatic' is missing the following prope... Remove this comment to see the full error message
    this.field = $(field);
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    this.fieldContainer = this.field.parent();
    if (!this.i18n) {
      // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'CalendarLocale'.
      this.i18n = CalendarLocale.getDaterangeTranslations(CalendarLocale.locale);
    }

    // Render new calendar if it's not already available.
    if (
      this.domObject === undefined ||
      this.domObject.length === 0 ||
      !this.domObject.is(this.fieldContainer.siblings('div.date_range'))
    ) {
      this.setup();

      // Show the existing calendar
    } else if (!this.domObject.is(':visible')) {
      this.domObject.show();
      this.setupOneTimeHandlers();
    }

    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    this.processRaw(this.field.val());
    window.merchantos.datepicker.init();
  },

  setup() {
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    this.hiddenStartField = $(this.fieldContainer).siblings('input.start_date');
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    this.hiddenEndField = $(this.fieldContainer).siblings('input.end_date');

    const template = window.Handlebars.compile($('#hb-date_range').html());
    window.Handlebars.registerPartial('month', $('#hb-date_range_month').html());
    const context = { humanized: this.formatted(), months: [] };

    $.each(_.range(1, 4), (i) =>
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ name: string; data: string; da... Remove this comment to see the full error message
      context.months.push(window.merchantos.calendar.monthData(Date.create().rewind({ month: i })))
    );

    context.months = context.months.reverse();

    const date_field_picker = template(context);

    if (this.domObject) {
      this.domObject.off('.pikaday').remove();
    }

    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    this.fieldContainer.after(date_field_picker);
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    this.domObject = this.fieldContainer.siblings('div.date_range');

    this.setupHandlers();
  },

  // This are events we'll need to only run once after setting up this event.
  setupOneTimeHandlers() {
    // Hide picker on click outside of the picker
    $('html')
      .off('click.pikaday')
      .on('click.pikaday', null, { picker: this }, (event) => {
        const target = $(event.target);
        if (!target.hasClass('pika-select')) {
          event.data.picker.hide();
        }
      });

    // Hide picker on form submission
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    this.domObject
      .parents('form')
      .off('submit.pikaday')
      .one('submit.pikaday', null, { picker: this }, (event) => event.data.picker.hide());

    // Hide picker on escape key in field or without focus
    $(document)
      .off('keyup', window.hideDateRangeViaEscapeKey)
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      .on('keyup.pikaday.esc', null, { picker: this }, window.hideDateRangeViaEscapeKey);
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    this.field
      .off('keyup', window.hideDateRangeViaEscapeKey)
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      .on('keyup.pikaday.esc', null, { picker: this }, window.hideDateRangeViaEscapeKey);
  },

  // Register Handlers
  setupHandlers() {
    this.setupOneTimeHandlers();

    // Prevent generic clicks from bubbling (prevents picker from being hidden in wrong cases)
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    this.domObject.off('.pikaday').on('click.pikaday', null, (event) => event.stopPropagation());
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    this.field.off('.pikaday').on('click.pikaday', null, (event) => event.stopPropagation());

    // Watch for changes via date fields
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    this.domObject
      .find('input[type="date"]')
      .off('change.pikaday')
      .on('change.pikaday', { picker: this }, function onChangeDate(event) {
        let field;
        if ($(this).attr('class') === 'start') {
          field = 'startingDate';
        } else {
          field = 'endingDate';
        }
        let value;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'create' does not exist on type 'DateCons... Remove this comment to see the full error message
        if (Date.create($(this).val()).isValid()) {
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'create' does not exist on type 'DateCons... Remove this comment to see the full error message
          value = Date.create($(this).val());
        } else {
          value = undefined;
        }

        event.data.picker.set(field, value);
      });

    // Watch for calendar scrolling
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    this.domObject
      .find('a.add_calendar')
      .off('click.pikaday')
      .on('click.pikaday', { picker: this }, function onClickCalendar(event) {
        let direction;
        if ($(this).hasClass('prev')) {
          direction = 'prev';
        } else {
          direction = 'next';
        }
        event.data.picker.addCalendar(direction);
      });

    // Watch for single-ended range (infinity) choices
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    this.domObject
      .find('a.open_range')
      .off('click.pikaday')
      .on('click.pikaday', { picker: this }, function onClickRangePicker(event) {
        if ($(this).hasClass('after')) {
          event.data.picker.setInfinite('end');
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          if (event.data.picker.startingDate.getFullYear() === -1) {
            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Date' is not assignable to param... Remove this comment to see the full error message
            event.data.picker.set('startingDate', new Date());
          }
        } else {
          event.data.picker.setInfinite('start');
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          if (event.data.picker.endingDate.getFullYear() === -1) {
            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Date' is not assignable to param... Remove this comment to see the full error message
            event.data.picker.set('endingDate', new Date());
          }
        }
      });

    // Watch for changes via the calendars
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    this.domObject.on('click.pikaday', '.month li', { picker: this }, function onClickMonth(event) {
      if (!$(this).hasClass('prev') && !$(this).hasClass('next')) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'create' does not exist on type 'DateCons... Remove this comment to see the full error message
        event.data.picker.pickDay(Date.create($(this).data('day')));
      }
    });

    // Watch for changes via the month heading
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    this.domObject.on('click.pikaday', 'h4', { picker: this }, function onClickH4(event) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'create' does not exist on type 'DateCons... Remove this comment to see the full error message
      event.data.picker.selectMonth(Date.create($(this).data('month')));
    });

    // Watch for changes via text input
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    this.field.on('keyup.pikaday', { picker: this }, function onCalendarKeyup(event) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number | string[] | und... Remove this comment to see the full error message
      event.data.picker.processRaw($(this).val(), event.keyCode === 13);
    });

    // Watch for changes via the shortcuts
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    this.domObject
      .find('.date_range_shortcuts a')
      .off('click.pikaday')
      .on('click.pikaday', { picker: this }, function onCalendarShortcut(event) {
        event.preventDefault();
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
        event.data.picker.processRaw($(this).attr('href'));
      });

    $(document).on('blur', 'input.date_range', this.updateField.bind(this));
  },

  hide() {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    this.domObject.hide();
  },

  // @ts-expect-error ts-migrate(2322) FIXME: Type '(direction: string) => true | undefined' is ... Remove this comment to see the full error message
  // eslint-disable-next-line consistent-return
  addCalendar(direction) {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    const months = this.domObject.find('ol.months');

    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    const first_month = $(_.first(months.find('> li:visible')));
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    const last_month = $(_.last(months.find('> li:visible')));
    let new_month;

    if (direction === 'prev') {
      // Check if there's already a month before this one and show it
      // instead of rendering a fresh one.
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'prev' does not exist on type 'JQueryStat... Remove this comment to see the full error message
      if (first_month.prev().length > 0) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'prev' does not exist on type 'JQueryStat... Remove this comment to see the full error message
        first_month.prev().show();
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'hide' does not exist on type 'JQueryStat... Remove this comment to see the full error message
        last_month.hide();

        this.updateCalendars();
        return true;
      }

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'create' does not exist on type 'DateCons... Remove this comment to see the full error message
      new_month = Date.create(first_month.find('h4').data('month')).rewind({ month: 1 });
    } else {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'next' does not exist on type 'JQueryStat... Remove this comment to see the full error message
      if (last_month.next().length > 0) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'next' does not exist on type 'JQueryStat... Remove this comment to see the full error message
        last_month.next().show();
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'hide' does not exist on type 'JQueryStat... Remove this comment to see the full error message
        first_month.hide();

        this.updateCalendars();
        return true;
      }

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'create' does not exist on type 'DateCons... Remove this comment to see the full error message
      new_month = Date.create(last_month.find('h4').data('month')).advance({ month: 1 });
    }

    const template = window.Handlebars.compile($('#hb-date_range_month').html());
    const context = window.merchantos.calendar.monthData(new_month);
    const template_html = template(context);

    if (direction === 'prev') {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'before' does not exist on type 'JQuerySt... Remove this comment to see the full error message
      first_month.before(template_html);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'hide' does not exist on type 'JQueryStat... Remove this comment to see the full error message
      last_month.hide();
    } else {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'after' does not exist on type 'JQuerySta... Remove this comment to see the full error message
      last_month.after(template_html);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'hide' does not exist on type 'JQueryStat... Remove this comment to see the full error message
      first_month.hide();
    }

    this.updateCalendars();
  },

  ask(...args) {
    let raw;
    if (!args[0]) {
      // eslint-disable-next-line no-alert
      raw = window.prompt('What date range would you like?', 'Today');
    } else {
      raw = args[0];
    }

    if (raw !== null) {
      return window.merchantos.dateRange.processRaw(raw);
    }
    return false;
  },

  processRaw(raw, isSubmit) {
    let start;
    let end;

    if (raw) {
      let dates = raw.match(/[\d-]+/g) as string[];

      if (Array.isArray(dates)) {
        if (dates.length === 2) {
          start = dates[0];
          end = dates[1];
        } else if (this.regexp.on.test(raw.trim())) {
          // eslint-disable-next-line no-multi-assign
          start = end = dates[0];
        } else if (this.regexp.before.test(raw)) {
          end = dates[0];
        } else if (this.regexp.after.test(raw)) {
          start = dates[0];
        } else {
          // Handle the case when start date or end date is null
          const dateRange = raw.split('to').map((item) => item.trim());
          start = dateRange[0] ? dateRange[0] : DEFAULT_MIN_DAY;
          end = dateRange[1] ? dateRange[1] : DEFAULT_MAX_DAY;
        }
      } else if (raw.match(this.regexp.to)) {
        dates = raw.split(this.regexp.to);

        // @ts-expect-error ts-migrate(2339) FIXME: Property 'create' does not exist on type 'DateCons... Remove this comment to see the full error message
        start = Date.create(dates[0], 'en');
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'create' does not exist on type 'DateCons... Remove this comment to see the full error message
        end = Date.create(dates[1], 'en');
      } else {
        // eslint-disable-next-line no-multi-assign
        start = end = raw;
      }

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'create' does not exist on type 'DateCons... Remove this comment to see the full error message
      start = start ? Date.create(start) : undefined;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'create' does not exist on type 'DateCons... Remove this comment to see the full error message
      end = end ? Date.create(end) : undefined;
    }

    if ((start === undefined || start.isValid()) && (end === undefined || end.isValid())) {
      const minDate = window.merchantos.datepicker.getPikadayConfig().minDate;
      const maxDate = window.merchantos.datepicker.getPikadayConfig().maxDate;

      this.startingDate = start >= minDate && start <= maxDate ? start : minDate;
      this.endingDate = end <= maxDate && end >= minDate ? end : maxDate;

      if (isSubmit) {
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        this.field.val(this.formatted(LEGACY_ISO8601_DATE));
      }

      this.reCalc();
    }
  },
};

window.hideDateRangeViaEscapeKey = function hideDateRangeViaEscapeKey(event) {
  if (event.keyCode === 27) {
    event.data.picker.hide();
    $(document).off('keyup', window.hideDateRangeViaEscapeKey);
    event.data.picker.field.off('keyup', hideDateRangeViaEscapeKey);
  }
};

window.merchantos.calendar = {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'create' does not exist on type 'DateCons... Remove this comment to see the full error message
  date: Date.create('today'),
  include_preceding: true,

  // @month - (optional) month in text (feb or feburary)
  // @year - (optional) year to allow for proper calculation of leap years
  // @include_preceding - (optional) include negative days from previous month to round out first week
  _parseParams(args) {
    if (args[0]) {
      this.date = args[0];
    }
  },

  // Gives a list of days in a month as an array.
  daysInMonth(...args) {
    this._parseParams(args);

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'daysInMonth' does not exist on type 'Dat... Remove this comment to see the full error message
    const range = _.range(1, this.date.daysInMonth() + 1);

    // ZeroPad days
    const days = _.map(range, (d) => {
      if (d >= 10) {
        return d.toString();
      }
      return `0${d}`;
    });

    return days;
  },

  // Gives a list of days in the week preceding the first day of the month specified
  weekdaysPrecedingFirstDayOfMonth(...args) {
    this._parseParams(args);

    const days: string[] = [];
    const date = this.date; // Get date in fuction scope

    // We don't need to fill in before month if it starts on a sunday
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'beginningOfMonth' does not exist on type... Remove this comment to see the full error message
    if (this.date.beginningOfMonth().getDay() !== 0) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'beginningOfMonth' does not exist on type... Remove this comment to see the full error message
      $.each(_.range(0, this.date.beginningOfMonth().getDay()).reverse(), (_i, instance) => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'create' does not exist on type 'DateCons... Remove this comment to see the full error message
        const working_date = Date.create([date.full(), CalendarLocale.locale])
          .beginningOfMonth()
          .rewind({ day: instance + 1 });
        days.push(working_date.format('{d}'));
      });
    }

    return days;
  },

  weekdaysFollowingLastDayOfMonth(...args) {
    this._parseParams(args);

    const days: TSFixMe = [];
    const date = this.date; // Get date in fuction scope

    // We don't need to fill out month if it ends on a saturday
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'endOfMonth' does not exist on type 'Date... Remove this comment to see the full error message
    if (this.date.endOfMonth().getDay() !== 6) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'endOfMonth' does not exist on type 'Date... Remove this comment to see the full error message
      $.each(_.range(1, 7 - this.date.endOfMonth().getDay()), (_i, instance) => {
        // @ts-ignore
        const working_date = Date.create([date.full(), CalendarLocale.locale])
          .endOfMonth()
          .advance({ day: instance });
      });
    }

    return days;
  },

  monthData(month) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'format' does not exist on type 'Date'.
    let name = month.format('{month}');

    // Show year if the given month isn't in the current year
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'getYear' does not exist on type 'Date'.
    if (month.getYear() !== Date.create().getYear()) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'format' does not exist on type 'Date'.
      name = month.format('{month} {year}');
    }

    return {
      name,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'format' does not exist on type 'Date'.
      data: month.format('{yyyy}-{MM}'),
      days: window.merchantos.calendar.daysInMonth(month),
      preceding_days: window.merchantos.calendar.weekdaysPrecedingFirstDayOfMonth(month),
      following_days: window.merchantos.calendar.weekdaysFollowingLastDayOfMonth(month),
    };
  },

  extendedDateRangeFieldHelper(field, config) {
    // Helper function that checks if the provided field is one that needs an
    // extended date range that goes back further than 2000.
    if (
      field.prop('id') === 'view_dob' ||
      field.prop('id') === 'quick_customer_dob' ||
      field.hasClass('cf-date-input')
    ) {
      config.minDate = moment(DEFAULT_MIN_DAY, 'YYYY-MM-DD').toDate();
      config.maxDate = moment(DEFAULT_MAX_DAY, 'YYYY-MM-DD').toDate();
      config.yearRange = [1900, 2038];
    }
  },
};

window.merchantos.datepicker = {
  getPikadayConfig() {
    return {
      firstDay: 0,
      minDate: moment(DEFAULT_MIN_DAY, 'YYYY-MM-DD').toDate(),
      maxDate: moment(DEFAULT_MAX_DAY, 'YYYY-MM-DD').toDate(),
      yearRange: [1900, 2038],
      // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'CalendarLocale'.
      i18n: CalendarLocale.getPikadayTranslations(),
      defaultDate: new Date(
        moment()
          .subtract({
            days: 0,
          })
          .toDate()
      ),
    };
  },

  getTimePickerConfig() {
    return {
      scrollDefault: 'now',
      timeFormat: 'h:i a',
      step: 15,
      showOn: ['focus', 'input'],
    };
  },

  updatePikadayInputs() {
    const inputs = $('input[pikaday="true"]');

    for (let i = 0, ii = inputs.length; i < ii; ++i) {
      inputs.eq(i).data('pikaday').destroy();
      inputs.eq(i).removeData('pikaday');
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 2.
      this.initPikadayInput(inputs.eq(i), true);
    }
  },

  initPikadayInput(input) {
    const pikadayConfig = $.extend({}, this.getPikadayConfig());
    if (input.val() === '0000-00-00') {
      input.val('');
    }

    // check if this field needs an extended date range.
    window.merchantos.calendar.extendedDateRangeFieldHelper(input, pikadayConfig);

    input.off('blur.pikaday').on('blur.pikaday', () => input.val(window.parseDateField(input[0])));

    const inputOnkeypress = input.attr('onkeypress');
    input.removeAttr('onkeypress');

    input.on('keydown', (event) => {
      if (event.keyCode === 13) {
        const oldValue = input.val();
        input.val(window.parseDateField(input[0]));

        // This is used to push the saveRecord function after Pickaday updates the input value, it allows
        // to validate that the date is within the min/max range comparing the before and after values
        setTimeout(() => {
          if (oldValue === input.val()) {
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            input.attr('onkeypress', inputOnkeypress);
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            input.trigger({ type: 'keypress', which: 13, keycode: 13 });
          }
        });
      }
    });

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'pikaday' does not exist on type 'JQuery<... Remove this comment to see the full error message
    input.pikaday(pikadayConfig);
  },

  initPikadayInputs(inputs) {
    $.each(inputs, (_idx, input) => {
      const dateTimeWrapper = $('<div class="date-wrapper"></div>');
      if ($(input).data('time')) {
        dateTimeWrapper.addClass('date-time-wrapper');
      }
      $(input).wrap(dateTimeWrapper);

      window.merchantos.datepicker.initPikadayInput($(input));
    });
  },

  initTimePickers(inputs) {
    $.each(inputs, (_idx, field) => {
      // eslint-disable-next-line no-param-reassign
      field = $(field);
      const dateTimeWrapper = $('<div class="time-wrapper"></div>');
      if (field.data('date')) {
        dateTimeWrapper.addClass('date-time-wrapper');
      }

      if (field.val() === '00:00' && field.data('date') === '0000-00-00') {
        field.val('');
      }

      field.wrap(dateTimeWrapper);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'timepicker' does not exist on type 'JQue... Remove this comment to see the full error message
      field.timepicker(window.merchantos.datepicker.getTimePickerConfig());

      field.on('keydown', (e) => {
        if (e.keyCode === 13) {
          field.trigger('change', 'timepicker');
          if (field.is(':focus')) {
            field.trigger('blur');
          }
        }
      });
    });
  },

  init() {
    // In order to support placeholder text,  all date fields have to be converted
    // to text.  Do this for all browsers,  but not for iOS
    if (!navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
      this.initPikadayInputs(
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement> & string' is... Remove this comment to see the full error message
        $('input[type="date"]')
          .attr('type', 'text')
          // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
          .attr('pikaday', true)
      );
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement>' is not assi... Remove this comment to see the full error message
      this.initTimePickers($('input[type="time"]').attr('type', 'text'));
    }
  },
};

window.zeroPad = function zeroPad(num, numZeros) {
  const n = Math.abs(num);
  const zeros = Math.max(0, numZeros - Math.floor(n).toString().length);
  let zeroString = (10 ** zeros).toString().substr(1);
  if (num < 0) {
    zeroString = `-${zeroString}`;
  }

  return zeroString + n;
};

window.padYear = function padYear(number) {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
  if (parseInt(number, 10) < 10) {
    return `200${number}`;
  }
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
  if (parseInt(number, 10) < 100) {
    return `20${number}`;
  }
  return String(number);
};

window.parseDate = function parseDate(input) {
  const parts = input.match(/(\d+)/g);
  // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
  return new Date(Date.UTC(parts[0], parts[1] - 1, parts[2], 12, 0, 0));
};

window.isValidDate = function isValidDate(d) {
  if (Object.prototype.toString.call(d) !== '[object Date]') {
    return false;
  }
  // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
  return !isNaN(d.getTime());
};

$(() => {
  window.merchantos.datepicker.init();

  // iOS Safari doesn't send onChange on some fields so we'll manually trigger it on Blur
  // This may need to be expanded to other fields but date and time fields are the only identified problem field types
  if (navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
    $('input[type="date"], input[type="time"]').on('blur', function onDateBlur() {
      $(this).change();
    });
  }
});
